import styled from "styled-components";

import CellEntityAvatar from "../CellEntityAvatar";

import {
  CellEntity,
  ArrowIn,
  CellEntityContainer,
  CellEntityTitle,
} from "~/templates/transactions/components/TransactionRow";
import { VASP } from "~/types/vaspid";

type IncomingTxDisplayProps = {
  customerLogo?: string | null;
  customerDisplayText: string;
  counterpartyLogo?: string | null;
  counterpartyDisplayText: string;
  counterPartyVASP?: VASP;
};

const FlexContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80%;
`;

export default function IncomingTxDisplay({
  customerLogo = "/assets/vasp-fallback.png",
  customerDisplayText,
  counterpartyLogo = "/assets/vasp-fallback.png",
  counterpartyDisplayText,
  counterPartyVASP,
}: IncomingTxDisplayProps) {
  return (
    <FlexContainer>
      <CellEntity id="beneficiary" title={"beneficiary"} logo={customerLogo} className="localize-ignore">
        {customerDisplayText}
      </CellEntity>
      <div style={{ alignSelf: "center", margin: "10px" }}>
        <ArrowIn />
      </div>
      {counterPartyVASP && (
        <CellEntityContainer>
          {counterpartyLogo && <CellEntityAvatar src={counterpartyLogo} />}
          <CellEntityTitle id="counterPartyVASP" title={counterPartyVASP.did} className="localize-ignore">
            {counterPartyVASP.name || counterPartyVASP.did}
          </CellEntityTitle>
        </CellEntityContainer>
      )}

      <CellEntity id="originator" title={"originator"} logo={counterpartyLogo} className="localize-ignore">
        {counterpartyDisplayText}
      </CellEntity>
    </FlexContainer>
  );
}
